import i18n from "~/plugins/i18n";
export default [
    {
        value: 'without_interval',
        label: i18n.t("without_interval"),
    },
    {
        value: '1_month',
        label: i18n.t("1_month"),
    },
    {
        value: '2_months',
        label: i18n.t("2_months"),
    },
    {
        value: '3_months',
        label: i18n.t("3_months"),
    },
    {
        value: '1_year',
        label: i18n.t("1_year"),
    },
]